import {
	TAnyValuesObject,
	TChangeNumber,
} from "components/ProjectSpecificComponents/Interfaces/GlobalInterface"
import { useState, useEffect, useMemo } from "react"

/**
 * Takes an array and slices it for tables one page.
 * Also handles how many items are presented in single tables page.
 */

export const useHandlePagination = (filteredItems: TAnyValuesObject[]) => {
	const [currentPage, setCurrentPage] = useState<number>(1)
	const [itemsPerPage, setItemsPerPage] = useState<number>(10)
	const [totalItemCount, setTotalItemCount] = useState<number>(0)

	const calcPageCount = () => Math.ceil(totalItemCount / itemsPerPage)

	const [pageCount, setPageCount] = useState<number>(calcPageCount())

	const changeRowsPerPage: TChangeNumber = (number: number) => setItemsPerPage(number)

	const onePageData = useMemo(() => {
		const dataForFiltering = [...filteredItems]
		const indexOfLastRow = currentPage * itemsPerPage
		const indexOfFirstRow = indexOfLastRow - itemsPerPage
		const currentData = dataForFiltering.slice(indexOfFirstRow, indexOfLastRow)
		return currentData
	}, [filteredItems])

	useEffect(() => {
		setPageCount(calcPageCount)
		filteredItems.length > 0 && setTotalItemCount(filteredItems.length)
	}, [filteredItems])

	const paginate: TChangeNumber = (number: number) => setCurrentPage(number)

	return {
		onePageData,
		totalItemCount,
		itemsPerPage,
		changeRowsPerPage,
		currentPage,
		paginate,
		pageCount,
	}
}

export default useHandlePagination
